import React from "react";
import { Box, Flex } from "rebass";
import styled from "styled-components";
import { EClipsViews, TClipsTypeSelectorProps } from "../../@types";

export const ClipsTypeSelector = ({
  isProfile,
  view,
  handleViewChange,
}: TClipsTypeSelectorProps) => {
  const ProfileTabs = () => {
    if (!isProfile) return <></>;
    return (
      <>
        <StyledDivider />
        <ResponsiveText
          active={EClipsViews.Mobile === view}
          onClick={() => handleViewChange(EClipsViews.Mobile)}
        >
          {EClipsViews.Mobile}
        </ResponsiveText>
        <StyledDivider />
        <ResponsiveText
          active={EClipsViews.Following === view}
          onClick={() => handleViewChange(EClipsViews.Following)}
        >
          {EClipsViews.Following}
        </ResponsiveText>
      </>
    );
  };

  return (
    <StyledFlex mb={[3, 3, 4, 4]} justifyContent="left" alignItems="center">
      <ResponsiveText
        active={EClipsViews.Clips === view}
        onClick={() => handleViewChange(EClipsViews.Clips)}
      >
        {EClipsViews.Clips}
      </ResponsiveText>
      <StyledDivider />
      <ResponsiveText
        active={EClipsViews.Montages === view}
        onClick={() => handleViewChange(EClipsViews.Montages)}
      >
        Career Montages
      </ResponsiveText>
      <ProfileTabs />
    </StyledFlex>
  );
};

const StyledFlex = styled(Flex)`
  gap: 12px;

  @media (max-width: ${(props) => props.theme.breaks.medium}) {
    height: 25px;
  }
`;

const Text = styled(Box)<{ active?: boolean }>`
  font-weight: 600;
  font-size: 26px;
  color: ${(props) => {
    return props.active
      ? props.theme.colors.ice
      : props.theme.colors.iceAlpha40;
  }};

  &:hover {
    cursor: pointer;
    color: ${(props) => {
      return props.theme.colors.envy;
    }};
  }

  @media (max-width: ${(props) => props.theme.breaks.standard}) {
    font-size: 22px;
  }

  @media (max-width: ${(props) => props.theme.breaks.medium}) {
    font-size: 18px;
  }
`;

const ResponsiveText = styled(Text)`
  @media (max-width: ${(props) => props.theme.breaks.standard}) {
    font-size: ${({ theme }) => theme.text.headline.fontSize};
  }

  @media (max-width: ${(props) => props.theme.breaks.medium}) {
    font-size: ${({ theme }) => theme.text.body.fontSize};
  }
`;

const StyledDivider = styled.div`
  width: 2px;
  height: 24px;
  background-color: ${(props) => {
    return props.theme.colors.navy;
  }};

  @media (max-width: ${(props) => props.theme.breaks.medium}) {
    height: 25px;
  }

  @media (max-width: ${(props) => props.theme.breaks.small}) {
    height: 14px;
  }
`;
